import theme from '../../theme';
const FOOTER_CSS = `
  .footer-root {
    border-top: 1px solid rgba(184, 149, 90, 0.15);
    padding: 18px 40px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    font-size: 12px;
    color: ${theme.textMuted};
  }
  @media (max-width: 600px) {
    .footer-root {
      grid-template-columns: 1fr !important;
      text-align: center;
      gap: 12px;
      padding: 20px 24px;
    }
    .footer-right {
      justify-content: center !important;
    }
  }
`;

function Footer() {
  return (
    <footer className="footer-root">
      <style>{FOOTER_CSS}</style>

      {/* Left: intentionally empty */}
      <div />

      {/* Centre: intentionally empty */}
      <div />

      {/* Right: LinkedIn */}
      <div className="footer-right" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px' }}>
        <a
          href="https://www.linkedin.com/in/ashokm-ca-cfa/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: theme.textMuted, display: 'flex', alignItems: 'center', transition: 'color 0.2s' }}
          onMouseOver={e => e.currentTarget.style.color = theme.gold}
          onMouseOut={e => e.currentTarget.style.color = theme.textMuted}
          aria-label="LinkedIn"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        </a>
      </div>

      {/* Compliance Disclaimer */}
      <div style={{
        gridColumn: '1 / -1',
        marginTop: '14px',
        fontSize: '9.5px',
        color: theme.textMuted,
        textAlign: 'center',
        lineHeight: '1.5',
        fontFamily: "'Josefin Sans', sans-serif",
        letterSpacing: '0.03em'
      }}>
        Disclaimer: All content and tools on Austrian Process are for educational purposes only and do not constitute financial advice, investment recommendations, or an offer to buy or sell securities.
      </div>
    </footer>
  );
}

export default Footer;
